export default "__VITE_ASSET__CLLeMBUx__"